import React, {useState} from 'react';
import { Modal, Button } from 'react-daisyui';

interface ChangeMeasureGroupConfirmModalProps {
    isOpen: boolean;
    closeModal: () => void;
    handleConfirm: () => void;
  }

const ChangeMeasureGroupConfirmModal: React.FC<ChangeMeasureGroupConfirmModalProps>  = ({
    isOpen,
    closeModal,
    handleConfirm
}) => {
    return (
        <Modal open={isOpen}>
        <Modal.Header>
            <h1>Confirm Group Change</h1>
        </Modal.Header>
        <Modal.Body>
            <p>Changing the group will reset the selected optional measures. Are you sure you want to proceed?</p>
        </Modal.Body>
        <Modal.Actions>
            <Button id='ModalCancelButton' type='button'  onClick={closeModal}>
            Cancel
            </Button>
            <Button id='ModalConfirmButton' type='button' color="primary" onClick={handleConfirm}>
            Confirm
            </Button>
        </Modal.Actions>
        </Modal>
    )
}

export default ChangeMeasureGroupConfirmModal;